export const settingList = [
  {
    id: "settings1",
    list: "계정",
  },
  {
    id: "settings2",
    list: "데이터 세이버",
  },
  {
    id: "settings3",
    list: "언어",
  },
  {
    id: "settings4",
    list: "재생하기",
  },
  {
    id: "settings5",
    list: "기기",
  },
  {
    id: "settings6",
    list: "자동차",
  },
  {
    id: "settings7",
    list: "개인정보 및 공개 범위",
  },
  {
    id: "settings8",
    list: "음성 도우미 및 앱",
  },
  {
    id: "settings9",
    list: "오디오 품질",
  },
  {
    id: "settings10",
    list: "동영상 화질",
  },
  {
    id: "settings11",
    list: "저장공간",
  },
  {
    id: "settings12",
    list: "알림",
  },
  {
    id: "settings13",
    list: "광고",
  },
  {
    id: "settings14",
    list: "로컬 파일",
  },
  {
    id: "settings15",
    list: "상세정보",
  },
];
